var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFillCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.5146H11.5V11.5146H15.5V9.51465H11.5V5.51465H9.5V9.51465H5.5V11.5146H9.5V15.5146ZM10.5 20.5146C9.11667 20.5146 7.81667 20.2521 6.6 19.7271C5.38333 19.2021 4.325 18.4896 3.425 17.5896C2.525 16.6896 1.8125 15.6313 1.2875 14.4146C0.7625 13.198 0.5 11.898 0.5 10.5146C0.5 9.13132 0.7625 7.83132 1.2875 6.61465C1.8125 5.39798 2.525 4.33965 3.425 3.43965C4.325 2.53965 5.38333 1.82715 6.6 1.30215C7.81667 0.777148 9.11667 0.514648 10.5 0.514648C11.8833 0.514648 13.1833 0.777148 14.4 1.30215C15.6167 1.82715 16.675 2.53965 17.575 3.43965C18.475 4.33965 19.1875 5.39798 19.7125 6.61465C20.2375 7.83132 20.5 9.13132 20.5 10.5146C20.5 11.898 20.2375 13.198 19.7125 14.4146C19.1875 15.6313 18.475 16.6896 17.575 17.5896C16.675 18.4896 15.6167 19.2021 14.4 19.7271C13.1833 20.2521 11.8833 20.5146 10.5 20.5146Z",
    fill: "#7C7A84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFillCircle);
export default __webpack_public_path__ + "static/media/add_fill_circle.30c390dfb7f124a0bf53bb0e55c8db4a.svg";
export { ForwardRef as ReactComponent };